import React from 'react';
import '../../assets/css/deTime.css';

class DeTime extends React.Component {
    TRANSITION = '100ms linear';
    NUMBER_TRANSLATION = ['日', '一', '二', '三', '四', '五', '六'];
  
    constructor() {
      super()
      this.state = {
        hourAngle: 0,
        minAngle: 0,
        secAngle: 0,
        transition: this.TRANSITION
      }
    }
  
    updateTime() {
      let date = new Date()
  
      let secAngle = (date.getSeconds() + date.getMilliseconds() / 1000) * 6;
      let minAngle = date.getMinutes() * 6 + secAngle / 60;
      let hourAngle = (date.getHours() % 12) * 30 + minAngle / 12;
  
      let transition = this.TRANSITION
      //  当秒针走到 0 的时候 角度其实是变小了 所以会倒着转 需要暂时删除 transition
      if (this.state.secAngle > secAngle) transition = null;
  
      this.setState({
        hourAngle: hourAngle,
        minAngle: minAngle,
        secAngle: secAngle,
        transition: transition
      })
    }
  
    componentWillMount() {
      this.updateTime();
  
      this.timer = setInterval(() => { this.updateTime() }, 100);
    }
  
    componentWillUnmount() {
      this.timer && clearTimeout(this.timer);
    }
  
    leadingZero(number) {
      return number < 10 ? '0' + number : number
    }
 
  
    render() {
      let hourArr = [...new Array(12).keys()]
      let grad = hourArr.map((item) => {
        return <div key={item} className="grad" style={{transform: `rotateZ(${item*30}deg)`}}></div>
      })
      let state = this.state
      let now = new Date()
  
      return (
        <div className="deTime">
          <div className="date">
            <div>{localStorage.getItem("loginUserName")},{now.getHours()<12?"上午 ":now.getHours()<14?"中午 ":"下午 "}好!　<a href="/">注销</a></div> 
          </div>　　　
          <div className="container">
            {grad}
            <div className="minute" style={{transform:  'rotateZ('+state.minAngle+'deg)'}}></div>
            <div className="hour" style={{transform:  'rotateZ('+state.hourAngle+'deg)'}}></div>
            <div className="second" style={{transition: state.transition, transform:  'rotateZ('+state.secAngle+'deg)'}}></div>
            <div className="center"></div>
          </div>
          <div className="time">
            {this.leadingZero(now.getHours())}:{this.leadingZero(now.getMinutes())}<span> {this.leadingZero(now.getSeconds())}</span>
          </div>
          <div className="date">
            <div>星期{this.NUMBER_TRANSLATION[now.getDay()]}　{now.getFullYear()}年{now.getMonth()+1<10?"0"+now.getMonth()+1:now.getMonth()+1}月{now.getDate()}日</div>
           
          </div>
          <div className="date">
            <div>城市:{localStorage.getItem("regionName")}</div>    
          </div>       
        </div>
      )
    }
  }
  export default DeTime;


// WEBPACK FOOTER //
// ./src/components/Model/DeTime.js